import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Breadcrumbs.css';

type Props = {
  inline?: boolean;
  className?: string;
};

const Breadcrumbs: React.FC<Props> = ({ inline = false, className = '' }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  // 去掉第一个为空的情况，并且不渲染首页(Home)；你的 Home 已在 Header 里单独显示
  // 比如 /user/change-password -> 渲染 user > change-password
  return (
    <nav className={`${inline ? 'app-breadcrumb--inline' : 'app-breadcrumb-nav'} ${className}`}>
      <ul className={`${inline ? 'app-breadcrumb app-breadcrumb--inline-list' : 'app-breadcrumb'}`}>
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isNonClickable = value === 'folder' || value === 'details';
          return (
            <React.Fragment key={to}>
              {index > 0 && <span className="app-breadcrumb-separator"> &gt; </span>}
              <li className={`app-breadcrumb-item ${isLast ? 'active' : ''}`}>
                {isLast || isNonClickable ? (
                  <span>{decodeURIComponent(value)}</span>
                ) : (
                  <Link to={to}>{decodeURIComponent(value)}</Link>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
